import type { Ref } from 'vue';
import { useQuery } from '@tanstack/vue-query';
import { unref } from 'vue';
import { getApi } from './api';

export default (accountId: Ref<number> | number) => {
  return useQuery({
    queryKey: [
      'account-map-overlays',
      () => unref(accountId),
    ],
    queryFn: () => {
      const { api, baseURL } = getApi();
      const actualAccountId = unref(accountId);

      return api.get(`/api/v2/accounts/${actualAccountId}/map-overlays`, {
        baseURL,
      }).then(res => res.data.data);
    },
    enabled: () => !!unref(accountId),
  });
};
